import React from 'react';

interface Mp4ExtProps {
    width?: number;
    height?: number;
}

export const Mp4Ext = ({ height = 26, width = 26 }: Mp4ExtProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
    >
        <g clipPath="url(#clip0_5885_18298)">
            <path
                d="M23.3269 5.11064L18.4519 0.235638C18.376 0.160337 18.2859 0.100762 18.1869 0.0603282C18.0879 0.0198946 17.9819 -0.000601989 17.875 1.34596e-05H4.875C3.52879 1.34596e-05 2.4375 1.0913 2.4375 2.43751V23.5625C2.4375 24.9087 3.52879 26 4.875 26H21.125C22.4712 26 23.5625 24.9087 23.5625 23.5625V5.68751C23.5631 5.58058 23.5426 5.47458 23.5022 5.37559C23.4618 5.27659 23.4022 5.18656 23.3269 5.11064ZM21.9375 23.5625C21.9375 24.0113 21.5738 24.375 21.125 24.375H4.875C4.42625 24.375 4.0625 24.0113 4.0625 23.5625V2.43751C4.0625 1.98876 4.42625 1.62501 4.875 1.62501H17.0625V4.87501C17.0625 5.77247 17.79 6.50001 18.6875 6.50001H21.9375V23.5625Z"
                fill="#D7D7D7"
            />
            <path
                d="M20 21.1667C20 21.625 19.625 22 19.1667 22H0.833333C0.375 22 0 21.625 0 21.1667V12.8333C0 12.375 0.375 12 0.833333 12H19.1667C19.625 12 20 12.375 20 12.8333V21.1667Z"
                fill="#6A5EB4"
            />
            <path
                d="M16.8023 17.7671V18.3652H13.2066L13.1929 17.9243L15.3736 14.5234H15.9717L15.3292 15.6514L13.9927 17.7671H16.8023ZM16.1461 14.5234V19.5H15.4078V14.5234H16.1461Z"
                fill="white"
            />
            <path
                d="M11.241 17.603H9.93188V16.9844H11.241C11.4802 16.9844 11.6739 16.9468 11.822 16.8716C11.9701 16.7941 12.0784 16.687 12.1467 16.5503C12.2151 16.4136 12.2493 16.2575 12.2493 16.082C12.2493 15.9202 12.2151 15.7676 12.1467 15.624C12.0784 15.4805 11.9701 15.3654 11.822 15.2788C11.6739 15.1899 11.4802 15.1455 11.241 15.1455H10.1472V19.5H9.37476V14.5234H11.241C11.6215 14.5234 11.9439 14.5907 12.2083 14.7251C12.4749 14.8573 12.6777 15.0407 12.8166 15.2754C12.9556 15.5101 13.0251 15.7767 13.0251 16.0752C13.0251 16.3965 12.9556 16.6711 12.8166 16.8989C12.6777 17.1268 12.4749 17.3011 12.2083 17.4219C11.9439 17.5426 11.6215 17.603 11.241 17.603Z"
                fill="white"
            />
            <path
                d="M3.82715 14.5234H4.53467L6.05566 18.4575L7.57666 14.5234H8.2876L6.33594 19.5H5.77539L3.82715 14.5234ZM3.53662 14.5234H4.19287L4.30566 17.7227V19.5H3.53662V14.5234ZM7.91846 14.5234H8.57471V19.5H7.80566V17.7227L7.91846 14.5234Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_18298">
                <rect width="26" height="26" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
